import React from 'react';
import { InputField } from '../../../utility/form';
import LoadingButton from '../../../utility/button/LoadingButton';
import useForgotPassword from './useForgotPassword';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../../../SEO/Seo';
import { metaContent } from '../../../SEO/metaContent';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const { form, onChange, onSubmit, loading, validate, result, errors } = useForgotPassword();

  return (<>
    {/* Meta tag */}
    <SEO {...metaContent.forgotPassword} />

    <div className="auth-card mx-auto ">
      <h3 className="text-center fw-bold mb-1">{t('forgotPassword.title')}</h3>
      <div className="text-center forgot-sub-heading" style={{ fontSize: '1rem', marginBottom: 20 }}>
        {t('forgotPassword.subtitle')}
      </div>
      <form onSubmit={onSubmit} noValidate>
        <div className="mb-3">
          <InputField
            label={t('forgotPassword.emailLabel')}
            name="email"
            value={form.email}
            onChange={onChange}
            error={errors.email}
            placeholder={t('forgotPassword.emailPlaceholder')}
            type="email"
          />
        </div>
        <LoadingButton
          type="submit"
          disabled={loading}
          isLoading={loading}
          className="w-100"
        >
          {t('forgotPassword.resetButton')}
        </LoadingButton>
      </form>
      <div className="mt-3 text-center">
        <Link
          to="/signin"
          className="signin-section-link btn-link ps-0"
          style={{
            pointerEvents: 'auto',
            cursor: 'pointer',
          }}
        >
          <i className="bi bi-arrow-left"></i>&nbsp;{t('forgotPassword.backToSignIn')}
        </Link>
      </div>
    </div>
  </>
  );
};

export default ForgotPassword;
